import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './ChatHeaderBar.css';

const ChatHeaderBar = ({
    chat,
    onBack,
    onClose,
    currentUserId,
}) => {
    const hasActiveChat = Boolean(chat && (chat._id || chat.id));

    const getChatDisplayInfo = () => {
        if (!hasActiveChat) {
            // ✅ Wrapped "Messenger" in a span to trigger your CSS styling
            return { title: <>talkear <span>Messenger</span></>, avatar: null };
        }

        // 1. Group Logic
        if (chat.type === 'GROUP' || chat.isGroup) {
            return {
                title: chat.name || chat.chatName || 'Group Chat',
                // Use 'avatar' (from model) or 'chatPicture' (from old code)
                avatar: chat.avatar || chat.chatPicture || '/group-avatar.png'
            };
        }

        // 2. DM Logic (Find the partner)
        // Check both 'participants' (normalized) and 'members' (raw from model)
        const membersList = chat.participants || chat.members || [];
        const partner = membersList.find(p => String(p._id || p) !== String(currentUserId));

        return {
            title: partner?.nickname || partner?.username || 'Conversation',
            avatar: partner?.profilePicture || partner?.avatar || '/default-avatar.png'
        };
    };

    const { title, avatar } = getChatDisplayInfo();

    // 🔍 DIAGNOSTIC LOG: Watch your F12 Console
    useEffect(() => {
        console.log("🟦 [ChatHeaderBar] Status:", {
            hasActiveChat,
            titleText: title,
            onCloseProvided: !!onClose, // Should be true!
            onBackProvided: !!onBack    // Should be true only when in a chat
        });
    }, [chat, title, onClose, onBack, hasActiveChat]);

    return (
        <div className="chat-header-bar">
            {/* LEFT SIDE: Back Button, Avatar, Title */}
            <div className="chat-header-left">
                {hasActiveChat && onBack && (
                    <button
                        className="chat-header-back"
                        onClick={onBack}
                        aria-label="Back to chat list"
                    >
                        ←
                    </button>
                )}

                {/* Display Avatar if it exists */}
                {hasActiveChat && avatar && (
                    <div
                        className="chat-header-avatar"
                        style={{
                            backgroundImage: `url(${avatar})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                    />
                )}

                <div className="chat-header-title">
                    {title}
                </div>
            </div>

            {/* RIGHT SIDE: Close Button */}
            <button
                className="chat-header-close"
                onClick={onClose}
                aria-label="Close chat"
            >
                ×
            </button>
        </div>
    );
};

ChatHeaderBar.propTypes = {
    chat: PropTypes.object,
    onBack: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    currentUserId: PropTypes.string,
};

export default ChatHeaderBar;